// extracted by mini-css-extract-plugin
export default {"filtersPanel":"AffiliateKpis_filtersPanel__qjgND","filterSelect":"AffiliateKpis_filterSelect__xQXD4"};